<template>
<div class="couponEdit form dialog-form">
    <el-dialog title="添加优惠码" :visible.sync="dialogVisible">
        <el-form :model="item" :rules="rules" ref="formName" label-width="120px" class="demo-ruleForm">
            <el-form-item label="优惠码名称" prop="name">
                <el-input v-model.trim="item.name" maxlength="30" show-word-limit clearable></el-input>
            </el-form-item>
            <el-form-item label="优惠码" class="no-margin" v-if="item.couponcode">
                <span>{{item.couponcode}}</span>
            </el-form-item>
            <el-form-item label="可使用次数" prop="totalusecount">
                <el-input v-model.trim="item.totalusecount" class="box" clearable></el-input><span>若不限制次数,请填0</span>
            </el-form-item>
            <el-form-item label="优惠方式" prop="couponvalue">
                <div class="form-content">
                    <div>
                        <el-radio-group v-model="item.couponusetype">
                            <el-radio :label="1">折扣减免</el-radio>
                            <el-radio :label="2">定额减免</el-radio>
                        </el-radio-group>
                    </div>
                    <div v-if="item.couponusetype==1">
                        <span class="title">原价减</span>
                        <el-input v-model.trim="item.couponvalue" class="box" clearable></el-input>%
                    </div>
                    <div v-if="item.couponusetype==2">
                        <span class="title">原价减</span>
                        <el-input v-model.trim="item.couponvalue" class="box" clearable></el-input>元
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="使用限制" class="no-margin">
                <el-checkbox v-model="item.isuselimit">优惠码每次仅可购买一张/套票券</el-checkbox>
            </el-form-item>
            <!--<el-form-item label="适用票种" prop="name">-->
            <!--<div class="form-content">-->
            <!--<el-checkbox-group v-model="item.checkList">-->
            <!--<el-checkbox label="0">全票</el-checkbox>-->
            <!--<el-checkbox label="1">会员票-￥299</el-checkbox>-->
            <!--</el-checkbox-group>-->
            <!--</div>-->
            <!--</el-form-item>-->
            <el-form-item label="有效期" class="no-margin">
                <el-checkbox v-model="item.isexpire">一直有效</el-checkbox>
                <el-date-picker v-model="item.date" v-if="!item.isexpire" type="datetimerange"
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item label="停止使用" class="no-margin">
                <el-checkbox v-model="item.status">停用此优惠码</el-checkbox>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
    </span>
    </el-dialog>
</div>
</template>

<script>
import {addVliveCoupon, getVliveCouponView, editVliveCoupon} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'couponEdit',
    data() {
        return {
            dialogVisible: false,
            item: {
                kmcinnerid: '',
                kmctype: '',
                innerid: '', // 优惠码id
                couponcode: '', // 优惠码（后台系统自动生成）
                name: '', // 优惠码名称
                coupontype: '1', // 优惠码类型 1普通 2裂变 3邀请 4积分兑换
                status: false, // 状态 1启用 9停用 100删除
                totalusecount: '', // 可用次数
                couponusetype: 1, // 优惠方式 1折扣减免 2定额减免
                couponvalue: '', // 优惠数值
                isuselimit: false, // 使用限制 0不限制 1仅可购买一张
                isexpire: true, // 有效期类型 1活动结束前皆可使用 2固定日期段
                date: [],
                expirebegindate: '', // 开始时间
                expireenddate: '' // 结束时间
            },
            rules: {
                name: [
                    {required: true, message: '请输入名称', trigger: 'blur'},
                    {min: 1, max: 30, message: '长度在1到30个字符', trigger: 'blur'}
                ],
                totalusecount: [
                    {required: true, message: '请输入可用次数', trigger: 'blur'},
                    {pattern: /^[0-9]*$/, message: '请输入数字', trigger: 'blur'}
                ],
                couponvalue: [
                    {required: true, message: '请输入优惠数值', trigger: 'blur'},
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '请输入正确的优惠数值（2位小数）', trigger: 'blur'}
                ]
            }
        }
    },
    mounted() {
    },
    methods: {
        openDialog(row) {
            this.dialogVisible = true
            // this.$refs.formName.resetFields()
            this.item.kmcinnerid = row.kmcinnerid
            this.item.kmctype = row.kmctype
            if (row.innerid) {
                this.item.innerid = row.innerid
                this._getView()
            }
        },
        cancel() {
            this.$refs.formName.resetFields()
            this.item.couponcode = ''
            this.dialogVisible = false
        },
        submit() {
            this.$refs.formName.validate((valid) => {
                if (valid) {
                    this.$confirm('确定要提交优惠码资料吗', '提交资料', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(() => {
                        let obj = Object.assign({}, this.item)
                        obj.status = obj.status ? '9' : '1'
                        obj.isuselimit = obj.isuselimit ? '1' : '0'
                        obj.isexpire = obj.isexpire ? '1' : '2'
                        obj.expirebegindate = obj.date[0]
                        obj.expireenddate = obj.date[1]
                        delete obj.date
                        if (this.item.innerid) {
                            this._editObject(obj)
                        } else {
                            this._addObject(obj)
                        }
                    }).catch()
                }
            })
        },
        _addObject(obj) {
            this.setLoading(true)
            addVliveCoupon({
                data: Object.assign({}, obj),
                success: data => {
                    this.$message.success('保存成功！')
                    this.setLoading(false)
                    this.$emit('getList')
                    this.cancel()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _editObject(obj) {
            this.setLoading(true)
            editVliveCoupon({
                data: Object.assign({}, obj),
                success: data => {
                    this.$message.success('保存成功！')
                    this.setLoading(false)
                    this.$emit('getList')
                    this.cancel()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getView() {
            this.setLoading(true)
            getVliveCouponView({
                data: {
                    innerid: this.item.innerid
                },
                success: data => {
                    let obj = Object.assign({}, data.data)
                    obj.status = obj.status === 9
                    obj.isuselimit = obj.isuselimit === 1
                    obj.isexpire = obj.isexpire === 1
                    obj.date = []
                    this.item = obj
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'loading'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.couponEdit {
    .box{
        width: 260px;
        margin-right: 10px;
    }
    .title{
        margin-right: 10px;
    }
    .no-margin{
        margin: 0;
    }
    .form-content{
        box-sizing: border-box;
        background: $bgcolor-lightgrey;
        padding: 5px 10px;
    }
    .el-input .el-input__count .el-input__count-inner{
        line-height: 1;
    }
}
</style>
